const STATUS_CARD = [
  { value: 0, label: "Hiệu lực" },
  { value: 1, label: "Hết hiệu lực" },
  { value: 2, label: "Hủy" },
];
const STATUS_DISCOUNT = [
  { value: 0, label: "Chưa bán" },
  { value: 1, label: "Đã bán" },
  { value: 2, label: "Đã dùng" },
  { value: 3, label: "Hủy" },
];
const HAN_THE_OPTIONS = [
  { value: 0, label: "Trọn đời" },
  { value: 12, label: "1 năm" },
  { value: 6, label: "6 tháng" },
];
export { STATUS_CARD, STATUS_DISCOUNT, HAN_THE_OPTIONS };
